"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_GRID_NEW_EMPTY_STORAGE_DATA = void 0;
exports.DATA_GRID_NEW_EMPTY_STORAGE_DATA = {
    columnSizes: {},
    columnVisibility: {},
    columnOrders: {}
};
//# sourceMappingURL=DataGridNewEmptyStorageData.js.map